import React, { useState, useEffect } from "react";

function KoicaHourly({ search }) {
  const [reportData, setReportData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Bugungi sana
  const [loading, setLoading] = useState(false);

  // --- O'ng tarafdagi Panel holatlari ---
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);

  // 24 soatlik massiv
  const hours = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, '0')}:00`);

  const fetchData = async (date) => {
    setLoading(true);
    try {
      const cleanDate = date.split('T')[0].split(':')[0];
      const response = await fetch(`https://koica-db.mwr.uz/api/smartwater?date=${cleanDate}`);
      const result = await response.json();

      if (result && result.success && Array.isArray(result.data)) {
        setReportData(result.data);
      } else if (Array.isArray(result)) {
        setReportData(result);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("KOICA ma'lumotlarini olishda xatolik:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(selectedDate);
  }, [selectedDate]);

  const handleObjectClick = (obj) => {
    setSelectedObject(obj);
    setIsPanelOpen(true);
  };

  const formatBattery = (batString) => {
    if (!batString || batString === "0") return "0%";
    return batString.replace("per", "") + "%";
  };

  // Tanlangan obyektning eng oxirgi soatlik ma'lumotlarini olish funksiyasi
  const getLastLog = (obj) => {
    if (obj && Array.isArray(obj.hourly_data) && obj.hourly_data.length > 0) {
      return obj.hourly_data[obj.hourly_data.length - 1];
    }
    return null;
  };

  // Qiymatlarni tekshirish (NaN, null yoki -9999 bo'lsa chiroyli chiqarish)
  const formatValue = (val, unit = "") => {
    if (val === null || val === undefined || val === "NaN" || isNaN(val) || parseFloat(val) === -9999) {
      return "-";
    }
    return `${parseFloat(val).toFixed(2)} ${unit}`;
  };

  const lastLog = getLastLog(selectedObject);

  return (
      <div className="p-3 w-100 position-relative" style={{ backgroundColor: "#fff", display: "flex", flexDirection: "column" }}>

        {/* Asosiy Kontent qismi */}
        <div style={{ marginRight: isPanelOpen ? "340px" : "0px", transition: "margin 0.3s ease" }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <h5 className="m-0 fw-bold" style={{ color: "#333" }}>
                KOICA stansiyalari soatlik suv ko'rsatkichlari (vol, m³/h)
              </h5>

              {/* Dinamik va 100% aniq statistika */}
              {!loading && reportData.length > 0 && (
                  <div className="mt-1 d-flex align-items-center" style={{ fontSize: "15px" }}>
        <span className="badge bg-success me-2">
          🟢 Ishlamoqda: {
          reportData.filter(obj => {
            // Jadvaldagi mantiq bilan bir xil tekshiruv (fr, wl va vol tekshiriladi)
            const hasNaN = hours.some((hour) => {
              const hourlyMatch = obj.hourly_data && obj.hourly_data.find((h) => {
                if (!h.time) return false;
                return (h.time.length > 5 ? h.time.substring(0, 5) : h.time) === hour;
              });

              if (hourlyMatch) {
                const frVal = hourlyMatch.fr;
                const wlVal = hourlyMatch.wl;
                const volVal = hourlyMatch.vol;

                return (
                    frVal === "NaN" || frVal === null || frVal === undefined || isNaN(frVal) ||
                    wlVal === "NaN" || wlVal === null || wlVal === undefined || isNaN(wlVal) || parseFloat(wlVal) === -9999 ||
                    volVal === "NaN" || volVal === null || volVal === undefined || isNaN(volVal)
                );
              }
              return false;
            });

            const isEmptyData = !obj.hourly_data || obj.hourly_data.length === 0;
            return !hasNaN && !isEmptyData; // Faqat mutlaqo muammosiz qatorlar
          }).length
        } ta
        </span>

                    <span className="badge bg-warning text-dark me-2">
          ⚠️ Muammoli: {
                      reportData.filter(obj => {
                        const hasNaN = hours.some((hour) => {
                          const hourlyMatch = obj.hourly_data && obj.hourly_data.find((h) => {
                            if (!h.time) return false;
                            return (h.time.length > 5 ? h.time.substring(0, 5) : h.time) === hour;
                          });

                          if (hourlyMatch) {
                            const frVal = hourlyMatch.fr;
                            const wlVal = hourlyMatch.wl;
                            const volVal = hourlyMatch.vol;

                            return (
                                frVal === "NaN" || frVal === null || frVal === undefined || isNaN(frVal) ||
                                wlVal === "NaN" || wlVal === null || wlVal === undefined || isNaN(wlVal) || parseFloat(wlVal) === -9999 ||
                                volVal === "NaN" || volVal === null || volVal === undefined || isNaN(volVal)
                            );
                          }
                          return false;
                        });

                        const isEmptyData = !obj.hourly_data || obj.hourly_data.length === 0;
                        return hasNaN || isEmptyData; // Sarg'aygan barcha qatorlar
                      }).length
                    } ta
        </span>

                    <span className="text-muted fw-bold">
          | Jami stansiyalar: {reportData.length} ta
        </span>
                  </div>
              )}
            </div>

            {/* Sanani tanlash qismi */}
            <div className="d-flex align-items-center">
              <label htmlFor="koica-date" className="me-2 fw-bold m-0" style={{ fontSize: "14px", whiteSpace: "nowrap", color: "#333" }}>Sanani tanlang:</label>
              <input
                  id="koica-date"
                  type="date"
                  className="form-control form-control-sm"
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  style={{ width: "160px" }}
              />
            </div>
          </div>

          {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Yuklanmoqda...</span>
                </div>
              </div>
          ) : (
              <div className="table-responsive" style={{ maxHeight: "72vh", overflowY: "auto", border: "1px solid #e1e6eb", borderRadius: "4px" }}>
                <table className="table table-bordered table-hover text-center align-middle m-0" style={{ minWidth: "1800px", fontSize: "13px", backgroundColor: "#ffffff" }}>
                  <thead>
                  <tr>
                    <th style={{
                      position: "sticky",
                      top: 0,
                      left: 0,
                      background: "#0b4aa9",
                      color: "#ffffff",
                      zIndex: 3,
                      width: "280px",
                      textAlign: "left",
                      padding: "10px 12px",
                      border: "1px solid #093d8c"
                    }}>
                      Ob'ekt nomi (obsvtr_nm)
                    </th>
                    {hours.map((hour) => (
                        <th key={hour} style={{
                          position: "sticky",
                          top: 0,
                          background: "#0b4aa9",
                          color: "#ffffff",
                          zIndex: 2,
                          width: "65px",
                          padding: "10px 4px",
                          border: "1px solid #093d8c"
                        }}>
                          {hour}
                        </th>
                    ))}
                  </tr>
                  </thead>
                  <tbody>
                  {reportData.length === 0 ? (
                      <tr>
                        <td colSpan={hours.length + 1} className="text-muted py-5 text-center" style={{ backgroundColor: "#ffffff" }}>
                          Ushbu sana uchun ma'lumot topilmadi.
                        </td>
                      </tr>
                  ) : (
                      reportData.map((obj, idx) => {
                        // --- ENG ISHONCHLI TEKSHIRUV ---
                        // Har bir soatni aylanib chiqamiz va jadval katagiga "NaN" yoki "-9999" to'g'ri kelishini aniqlaymiz
                        const hasNaN = hours.some((hour) => {
                          const hourlyMatch = obj.hourly_data && obj.hourly_data.find((h) => {
                            if (!h.time) return false;
                            const shortTime = h.time.length > 5 ? h.time.substring(0, 5) : h.time;
                            return shortTime === hour;
                          });

                          // Agar ma'lumot kelgan bo'lsa, uning qiymatlarini tekshiramiz
                          if (hourlyMatch) {
                            const frVal = hourlyMatch.fr;
                            const wlVal = hourlyMatch.wl;
                            const volVal = hourlyMatch.vol;

                            return (
                                frVal === "NaN" || frVal === null || frVal === undefined || isNaN(frVal) ||
                                wlVal === "NaN" || wlVal === null || wlVal === undefined || isNaN(wlVal) || parseFloat(wlVal) === -9999 ||
                                volVal === "NaN" || volVal === null || volVal === undefined || isNaN(volVal)
                            );
                          }

                          return false; // Agar o'sha soatda ma'lumot umuman bo'lmasa (och kulrang chiziqcha "-" bo'lsa), xato deb hisoblamaydi
                        });

                        // Agar kun bo'yi umuman log kelmagan bo'lsa ham xato (sariq) deb hisoblasin desangiz:
                        const isEmptyData = !obj.hourly_data || obj.hourly_data.length === 0;
                        const shouldBeYellow = hasNaN || isEmptyData;

                        const isSelected = selectedObject && selectedObject.object_id === obj.object_id;
                        const rowBgColor = isSelected ? "#e6f7ff" : (shouldBeYellow ? "#fff9db" : "#ffffff");

                        return (
                            <tr key={obj.object_id || idx} style={{ backgroundColor: rowBgColor }}>
                              {/* Chap ustun (Obyekt nomi) */}
                              <td
                                  className="fix-with fw-bold text-start"
                                  onClick={() => handleObjectClick(obj)}
                                  style={{
                                    position: "sticky",
                                    left: 0,
                                    background: rowBgColor,
                                    color: "#0b4aa9",
                                    zIndex: 1,
                                    borderRight: "2px solid #dee2e6",
                                    padding: "8px 12px",
                                    cursor: "pointer",
                                    userSelect: "none"
                                  }}
                                  onMouseEnter={(e) => e.currentTarget.style.textDecoration = "underline"}
                                  onMouseLeave={(e) => e.currentTarget.style.textDecoration = "none"}
                              >
                                🏢 {obj.obsvtr_nm || "Nomsiz ob'ekt"} <span className="text-muted fw-normal" style={{ fontSize: "11px" }}>({obj.unit || 'm³/h'})</span>
                              </td>

                              {hours.map((hour) => {
                                const hourlyMatch = obj.hourly_data && obj.hourly_data.find((h) => {
                                  if (!h.time) return false;
                                  const shortTime = h.time.length > 5 ? h.time.substring(0, 5) : h.time;
                                  return shortTime === hour;
                                });

                                // Katak ichidagi qiymatni aniq tekshirish
                                // Agar obyekt birligi "mln m³" (hajm) bo'lsa fr emas vol ni tekshirishi kerak, shuning uchun quyidagicha yozamiz:
                                let displayValue = "-";
                                let isNaNValue = false;

                                if (hourlyMatch) {
                                  // Stansiya turiga qarab tegishli qiymatni olamiz (agar birlikda 'hajmi' yoki 'mln' bo'lsa vol dan oladi)
                                  const isHajm = obj.unit && (obj.unit.includes("mln") || obj.unit.includes("hajm"));
                                  const rawVal = isHajm ? hourlyMatch.vol : hourlyMatch.fr;

                                  if (rawVal === null || rawVal === undefined || rawVal === "NaN" || isNaN(rawVal) || parseFloat(hourlyMatch.wl) === -9999) {
                                    isNaNValue = true;
                                    displayValue = "NaN";
                                  } else {
                                    displayValue = parseFloat(rawVal).toFixed(2);
                                  }
                                }

                                return (
                                    <td
                                        key={hour}
                                        style={{
                                          color: isNaNValue ? "#d9480f" : (hourlyMatch ? "#111111" : "#b0b8c1"),
                                          fontWeight: hourlyMatch && !isNaNValue ? "600" : "normal",
                                          padding: "8px 4px"
                                        }}
                                    >
                                      {displayValue}
                                    </td>
                                );
                              })}
                            </tr>
                        );
                      })
                  )}
                  </tbody>
                </table>
              </div>
          )}
        </div>

        {/* --- O'ng tarafdan ochiladigan Panel --- */}
        <div
            style={{
              position: "fixed",
              top: 0,
              right: isPanelOpen ? 0 : "-360px",
              width: "340px",
              height: "100vh",
              backgroundColor: "#ffffff",
              boxShadow: "-4px 0 15px rgba(0,0,0,0.15)",
              zIndex: 1050,
              transition: "right 0.3s ease-in-out",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box"
            }}
        >
          {selectedObject && (
              <>
                <div className="d-flex justify-content-between align-items-start border-b pb-2 mb-3" style={{ borderBottom: "1px solid #dee2e6" }}>
                  <div>
                    <h6 className="fw-bold m-0 text-primary" style={{ fontSize: "15px" }}>{selectedObject.obsvtr_nm}</h6>
                    <small className="text-muted">ID: {selectedObject.object_id}</small>
                  </div>
                  <button onClick={() => setIsPanelOpen(false)} className="btn-close" style={{ fontSize: "12px", cursor: "pointer" }}></button>
                </div>

                {/* Google Maps xaritasi */}
                <div className="w-100 mb-3 border rounded" style={{ height: "220px", overflow: "hidden", backgroundColor: "#f8f9fa" }}>
                  {selectedObject.lat && selectedObject.lon ? (
                      <iframe
                          title="Google Map"
                          width="100%"
                          height="100%"
                          style={{ border: 0 }}
                          allowFullScreen=""
                          loading="lazy"
                          src={`https://maps.google.com/maps?q=${selectedObject.lat},${selectedObject.lon}&z=14&output=embed`}
                      ></iframe>
                  ) : (
                      <div className="d-flex align-items-center justify-content-center h-100 text-muted">Geolokatsiya mavjud emas</div>
                  )}
                </div>

                {/* Dinamik Texnik Ma'lumotlar */}
                <div style={{ fontSize: "13px", overflowY: "auto", flex: 1 }} className="pe-1">
                  <h6 className="fw-bold text-secondary mb-2" style={{ fontSize: "13px" }}>So'nggi holat va ma'lumotlar:</h6>

                  <div className="p-2 mb-2 bg-light rounded border">
                    <span className="text-muted d-block" style={{ fontSize: "11px" }}>Oxirgi yangilangan vaqt:</span>
                    <strong className="text-dark">{lastLog ? lastLog.full_dt : "Ma'lumot yo'q"}</strong>
                  </div>

                  <div className="row g-2 mb-2">
                    <div className="col-6">
                      <div className="p-2 bg-light rounded border h-100">
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>Suv sarfi (fr):</span>
                        <strong className="text-dark" style={{ fontSize: "14px" }}>
                          {lastLog ? formatValue(lastLog.fr, selectedObject.unit) : "-"}
                        </strong>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="p-2 bg-light rounded border h-100">
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>Suv sathi (wl):</span>
                        <strong className="text-dark" style={{ fontSize: "14px" }}>
                          {lastLog ? formatValue(lastLog.wl, "m") : "-"}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div className="p-2 mb-2 bg-light rounded border">
                    <span className="text-muted d-block" style={{ fontSize: "11px" }}>Hajm (vol):</span>
                    <strong className="text-dark">{lastLog ? formatValue(lastLog.vol, "mln m³") : "-"}</strong>
                  </div>

                  <div className="row g-2 mb-2">
                    <div className="col-6">
                      <div className="p-2 bg-light rounded border">
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>Batareya quvvati:</span>
                        <strong>🔋 {lastLog ? formatBattery(lastLog.bat) : "Noma'lum"}</strong>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="p-2 bg-light rounded border">
                        <span className="text-muted d-block" style={{ fontSize: "11px" }}>Aloqa holati:</span>
                        <strong className={lastLog ? "text-success" : "text-danger"}>
                          {lastLog ? "🟢 Online" : "🔴 Offline"}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <div className="p-2 bg-light rounded border">
                    <span className="text-muted d-block" style={{ fontSize: "11px" }}>Jami kunlik loglar soni:</span>
                    <strong>📊 {selectedObject.total_logs || 0} ta log kelgan</strong>
                  </div>
                </div>
              </>
          )}
        </div>

      </div>
  );
}

export default KoicaHourly;